!function(e){"function"==typeof define&&define.amd?define('jqueryui-amd/ie',["jquery","./version"],e):e(jQuery)}(function(e){return e.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase())});
